import Dexie, { Table, Transaction } from 'dexie';
import { IExam } from '../interfaces/IExam';
import { IStudent } from '../interfaces/IStudent';
import { IExamStudent } from '../interfaces/IExamStudent';
import { IProgram } from '../interfaces/IProgram';
import { ICourse } from '../interfaces/ICourse';
import { IScanItem } from '../interfaces/IScanItem';
// import { checkMethod } from '../interfaces/IBarcodeScanResult';

export class AppDatabase extends Dexie {
    exams!: Table<IExam, string>;
    students!: Table<IStudent, string>;
    examStudents!: Table<IExamStudent, string>;
    programs!: Table<IProgram, string>;
    courses!: Table<ICourse, number>;
    scanHistory!: Table<IScanItem, string>;

    // async seedProgramsAndCourses(tx: Transaction) {
    //     const seedPrograms: IProgram[] = [
    //         { id: 'ABA-BK', name: 'Bachelor in de beeldende kunsten' },
    //         { id: 'ABA-DRA', name: 'Bachelor in het drama' },
    //         { id: 'ABA-MUZ', name: 'Bachelor in de muziek' },
    //         { id: 'ABA-VA', name: 'Bachelor of Arts in Visual Arts' },

    //         { id: 'AO-KC', name: 'Aanvullende opleiding Koninklijk Conservatorium' },
    //         { id: 'BNB-AUT', name: 'Bachelor autisme: een orthopedagogisch perspectief' },
    //         { id: 'BNB-TGE', name: 'Bachelor toegepaste gerontologie' },

    //         { id: 'EBA-KO', name: 'Educatieve bachelor in het kleuteronderwijs' },
    //         { id: 'EBA-LO', name: 'Educatieve bachelor in het lager onderwijs' },
    //         { id: 'EBA-SO', name: 'Educatieve bachelor in het secundair onderwijs' },
    //         { id: 'EBA-SO-A', name: 'Verkorte educatieve bachelor in het secundair onderwijs (Antwerpen)' },
    //         { id: 'EBA-SO-M', name: 'Verkorte educatieve bachelor in het secundair onderwijs (Mechelen)' },
    //         { id: 'EBA-SO-MPK', name: 'Verkorte educatieve bachelor muziek en podiumkunsten' },
    //         { id: 'EBA-SO-T', name: 'Verkorte educatieve bachelor in het secundair onderwijs (Turnhout)' },
    //         { id: 'EBA-SO1-A', name: 'Educatieve bachelor secundair onderwijs (1 onderwijsvak, Antwerpen)' },

    //         { id: 'EGRAD-A', name: 'Educatief graduaat in het secundair onderwijs (Antwerpen)' },
    //         { id: 'EGRAD-DANS', name: 'Educatief graduaat in het secundair onderwijs (dans)' },
    //         { id: 'EGRAD-M', name: 'Educatief graduaat in het secundair onderwijs (Mechelen)' },
    //         { id: 'EGRAD-T', name: 'Educatief graduaat in het secundair onderwijs (Turnhout)' },

    //         { id: 'EMA-BK', name: 'Educatieve master audiovisuele en beeldende kunsten' },
    //         { id: 'EMA-MPK', name: 'Educatieve master muziek en podiumkunsten' },
    //         { id: 'EMA-MPK-V', name: 'Verkorte educatieve master muziek en podiumkunsten' },

    //         { id: 'GRAD-AA', name: 'Graduaat accounting administration' },
    //         { id: 'GRAD-DVG', name: 'Graduaat digitale vormgeving' },
    //         { id: 'GRAD-EMS', name: 'Graduaat elektromechanische systemen' },
    //         { id: 'GRAD-HR', name: 'Graduaat HR-support (Antwerpen)' },
    //         { id: 'GRAD-HVAC', name: 'Graduaat HVAC-systemen' },
    //         { id: 'GRAD-IOT', name: 'Graduaat Internet of Things' },
    //         { id: 'GRAD-JAO', name: 'Graduaat juridisch-administratieve ondersteuning' },
    //         { id: 'GRAD-LRC', name: 'Graduaat logies-, restaurant- en cateringmanagement' },
    //         { id: 'GRAD-MCS', name: 'Graduaat marketing- en communicatiesupport' },
    //         { id: 'GRAD-MW', name: 'Graduaat maatschappelijk werk (Antwerpen)' },
    //         { id: 'GRAD-MW-M', name: 'Graduaat maatschappelijk werk (Mechelen)' },
    //         { id: 'GRAD-OB-A', name: 'Graduaat orthopedagogische begeleiding (Antwerpen)' },
    //         { id: 'GRAD-OB-M', name: 'Graduaat orthopedagogische begeleiding (Mechelen)' },
    //         { id: 'GRAD-OB-T', name: 'Graduaat orthopedagogische begeleiding (Turnhout)' },
    //         { id: 'GRAD-PRO', name: 'Graduaat programmeren' },
    //         { id: 'GRAD-SCW', name: 'Graduaat sociaal-cultureel werk' },
    //         { id: 'GRAD-SNB', name: 'Graduaat systeem- en netwerkbeheer' },
    //         { id: 'GRAD-TL', name: 'Graduaat transport en logistiek' },
    //         { id: 'GRAD-VZ', name: 'Graduaat verzekeringen' },
    //         { id: 'GRAD-WO', name: 'Graduaat werforganisatie' },

    //         // { id: 'GST', name: 'Gaststudenten' },

    //         { id: 'IPBR', name: 'International programmes Business and Law' },
    //         { id: 'IPCEL', name: 'International programme Community Engaged Learning' },
    //         { id: 'IPGW', name: 'International programmes Health and Life Science' },
    //         { id: 'IPIO', name: 'International programmes Industry and Environment' },
    //         { id: 'IPKA', name: 'International programmes Royal Academy' },
    //         { id: 'IPKCA', name: 'International programmes Royal Conservatoire' },
    //         { id: 'IPMDI', name: 'International programmes Media, Design and IT' },
    //         { id: 'IPMM', name: 'International programmes People and Society' },
    //         { id: 'IPOT', name: 'International programmes Education and Training' },

    //         { id: 'MA-AMU', name: 'Master of Arts in Music' },
    //         { id: 'MA-BK', name: 'Master in de beeldende kunsten' },
    //         { id: 'MA-DANCE', name: 'Master in Dance' },
    //         { id: 'MA-DANS', name: 'Master in de dans' },
    //         { id: 'MA-DRA', name: 'Master in het drama' },
    //         { id: 'MA-MUZ', name: 'Master in de muziek' },
    //         { id: 'MA-VA', name: 'Master of Arts in Visual Arts' },

    //         { id: 'MIC-BR', name: 'Microcredential Business & Recht (Insurance, Social Law of Sustainable Business)' },
    //         { id: 'MIC-GDM', name: 'Microcredential in de grafische en digitale Media' },
    //         { id: 'MIC-SPV', name: 'Microcredential sportvoeding' },
    //         { id: 'MIC-TP', name: 'Microcredential toegepaste psychologie' },

    //         { id: 'MO BR', name: 'Mobiliteitsopleiding Business en Recht' },
    //         { id: 'MO GW', name: 'Mobiliteitsopleiding Gezondheid en Wetenschap' },
    //         { id: 'MO IO', name: 'Mobiliteitsopleiding Industrie en Omgeving' },
    //         { id: 'MO KA', name: 'Mobiliteitsopleiding Koninklijke Academie' },
    //         { id: 'MO KCA', name: 'Mobiliteitsopleiding Koninklijk Conservatorium Antwerpen' },
    //         { id: 'MO MDI', name: 'Mobiliteitsopleiding Media, Design en IT' },
    //         { id: 'MO MM', name: 'Mobiliteitsopleiding Mens en Maatschappij' },
    //         { id: 'MO OT', name: 'Mobiliteitsopleiding Onderwijs en Training' },

    //         { id: 'PBA-BL', name: 'Bachelor in de biomedische laboratoriumtechnologie' },
    //         { id: 'PBA-BM', name: 'Bachelor in het bedrijfsmanagement' },
    //         { id: 'PBA-CH', name: 'Bachelor in de chemie' },
    //         { id: 'PBA-CM', name: 'Bachelor in de communicatie' },
    //         { id: 'PBA-DANS', name: 'Bachelor in de dans' },
    //         { id: 'PBA-E', name: 'Bachelor in de ergotherapie' },
    //         { id: 'PBA-EA', name: 'Bachelor in de elektronica-ICT' },
    //         { id: 'PBA-EM', name: 'Bachelor in de elektromechanica' },
    //         { id: 'PBA-ENE', name: 'Bachelor in het energiemanagement' },
    //         { id: 'PBA-GDM', name: 'Bachelor in de grafische en digitale media' },
    //         { id: 'PBA-HM', name: 'Bachelor in het hotelmanagement' },
    //         { id: 'PBA-HRM', name: 'Bachelor in het human resources management' },
    //         { id: 'PBA-IV', name: 'Bachelor in de integrale veiligheid' },
    //         { id: 'PBA-JOU', name: 'Bachelor in de journalistiek' },
    //         { id: 'PBA-OM', name: 'Bachelor in organisatie & management' },
    //         { id: 'PBA-OR', name: 'Bachelor in de orthopedagogie' },
    //         { id: 'PBA-RP', name: 'Bachelor in het bedrijfsmanagement (rechtspraktijk)' },
    //         { id: 'PBA-SW', name: 'Bachelor in het sociaal werk' },
    //         { id: 'PBA-TI', name: 'Bachelor in de toegepaste informatica' },
    //         { id: 'PBA-TP', name: 'Bachelor in de toegepaste psychologie' },
    //         { id: 'PBA-VD', name: 'Bachelor in de voedings- en dieetkunde' },
    //         { id: 'PBA-VG', name: 'Bachelor in het vastgoed' },
    //         { id: 'PBA-VK-FL', name: 'Bachelor in de verpleegkunde (flex)' },
    //         { id: 'PBA-VK4', name: 'Bachelor in de verpleegkunde (4j)' },
    //         { id: 'PBA-VR', name: 'Bachelor in de vroedkunde' },

    //         { id: 'PGR-COA', name: 'Postgraduaat Coaching' },
    //         { id: 'PGR-COMP', name: 'Postgraduaat Muziek - compositie' },
    //         { id: 'PGR-CSC', name: 'Postgraduaat contextuele systemische counseling' },
    //         { id: 'PGR-CSI', name: 'Postgraduaat Muziek - concertsolist: instrument' },
    //         { id: 'PGR-CSZ', name: 'Postgraduaat Muziek - concertsolist: zang' },
    //         { id: 'PGR-GV20', name: 'Postgraduaat Gespecialiseerde verpleegkundige in de kritische zorg' },
    //         { id: 'PGR-GV60', name: 'Postgraduaat Gespecialiseerde verpleegkundige in de kritische zorg: Praktijk integratie' },
    //         { id: 'PGR-JL', name: 'Postgraduaat Muziek - jazz' },
    //         { id: 'PGR-KA', name: 'Postgraduaat Muziek - kamermuziek' },
    //         { id: 'PGR-NCZ', name: 'Postgraduaat leraar niet-confessionele zedenleer basisonderwijs' },
    //         { id: 'PGR-OND', name: 'Postgraduaat ondernemen' },
    //         { id: 'PGR-ORK', name: 'Postgraduaat Muziek - orkestinstrument' },
    //         { id: 'PGR-SUZ1-2', name: 'Postgraduaat Muziek - Suzuki lerarenopleiding (Viool) ESA 1-2' },
    //         { id: 'PGR-SUZ3', name: 'Postgraduaat Muziek - Suzuki lerarenopleiding (Viool) ESA 3' },
    //         { id: 'PGR-SUZ4-5', name: 'Postgraduaat Muziek - Suzuki lerarenopleiding (Viool) ESA 4 -5' },
    //         { id: 'PGR-VW', name: 'Postgraduaat Vrijwilligerswerk' },

    //         { id: 'SCH-BK', name: 'Schakelprogramma Beeldende Kunsten' },
    //         { id: 'SCH-DANS', name: 'Schakelprogramma dans' },
    //         { id: 'SCH-MUZ-C', name: 'Schakelprogramma muziek - compositie' },
    //         { id: 'SCH-MUZ-DIR', name: 'Schakelprogramma muziek - directie' },
    //         { id: 'SCH-MUZ-I', name: 'Schakelprogramma muziek - instrument' },
    //         { id: 'SCH-MUZ-JL', name: 'Schakelprogramma muziek - jazz / lichte muziek' },
    //         { id: 'SCH-MUZ-Z', name: 'Schakelprogramma muziek - zang' },

    //         { id: 'VO-BR', name: 'Vrije opleiding Business en Recht' },
    //         { id: 'VO-GW', name: 'Vrije opleiding Gezondheid en Wetenschap' },
    //         { id: 'VO-HS', name: 'Vrije opleiding Hogeschool' },
    //         { id: 'VO-IO', name: 'Vrije opleiding Industrie en Omgeving' },
    //         { id: 'VO-KA', name: 'Vrije opleiding Koninklijke Academie' },
    //         { id: 'VO-KC', name: 'Vrije opleiding Koninklijk Conservatorium' },
    //         { id: 'VO-MDI', name: 'Vrije opleiding Media, Design en IT' },
    //         { id: 'VO-MM', name: 'Vrije opleiding Mens en Maatschappij' },
    //         { id: 'VO-OT', name: 'Vrije opleiding Onderwijs en Training' },

    //         { id: 'VP-BK', name: 'Voorbereidingsprogramma Beeldende Kunsten' },
    //         { id: 'VP-MPK', name: 'Voorbereidingsprogramma muziek en podiumkunsten' },

    //         { id: 'GRAD-LAB', name: 'Graduaat laboratoriumassistentie' },

    //         { id: 'PGR-PICU', name: 'Postgraduaat Kritieke pediatrie' }
    //     ];

    //     await tx.table('programs').bulkAdd(seedPrograms);

    //     const seedCourseUnits: ICourse[] = [
    //         { programId: 'PBA-TI', id: 231578, name: 'BPMN' },
    //         { programId: 'PBA-TI', id: 231579, name: 'Mobile development' },
    //         { programId: 'PBA-TI', id: 231580, name: 'Applied business project' },
    //         { programId: 'PBA-TI', id: 231581, name: 'Applied software project' },
    //         { programId: 'PBA-TI', id: 231582, name: 'Business intelligence' },
    //         { programId: 'PBA-TI', id: 231583, name: 'Project management' },
    //         { programId: 'PBA-TI', id: 231584, name: 'ERP cases' },
    //         { programId: 'PBA-TI', id: 231585, name: 'Sustainable project' },
    //         { programId: 'PBA-TI', id: 231586, name: 'Bachelorproef en stage' },
    //         { programId: 'PBA-TI', id: 231587, name: 'IT research' },
    //         { programId: 'PBA-TI', id: 231588, name: 'ERP development' },
    //         { programId: 'PBA-TI', id: 231589, name: 'ERP advanced' },
    //         { programId: 'PBA-TI', id: 231590, name: 'ERP applications' },
    //         { programId: 'PBA-TI', id: 231591, name: 'Business project' },
    //         { programId: 'PBA-TI', id: 231592, name: 'Data visualization' },
    //         { programId: 'PBA-TI', id: 231593, name: 'ML algorithms' },
    //         { programId: 'PBA-TI', id: 231594, name: 'Data engineering' },
    //         { programId: 'PBA-TI', id: 231595, name: 'AI programming' },
    //         { programId: 'PBA-TI', id: 231596, name: 'MLOps' },
    //         { programId: 'PBA-TI', id: 231597, name: 'Deep learning' },
    //         { programId: 'PBA-TI', id: 231598, name: 'Artificial intelligence project' },
    //         { programId: 'PBA-TI', id: 231599, name: 'Cyber security' },
    //         { programId: 'PBA-TI', id: 231600, name: 'Intro ERP' },
    //         { programId: 'PBA-TI', id: 231601, name: 'Database programming' },
    //         { programId: 'PBA-TI', id: 231602, name: 'Data structures' },
    //         { programId: 'PBA-TI', id: 231603, name: 'Requirement analysis' },
    //         { programId: 'PBA-TI', id: 231604, name: 'Mathematical foundations' },
    //         { programId: 'PBA-TI', id: 231605, name: 'ML Principles' },
    //         { programId: 'PBA-TI', id: 231606, name: 'Software design' },
    //         { programId: 'PBA-TI', id: 231607, name: 'Java' },
    //         { programId: 'PBA-TI', id: 231608, name: 'Software engineering' },
    //         { programId: 'PBA-TI', id: 231609, name: '.NET advanced' },
    //         { programId: 'PBA-TI', id: 231610, name: 'UX Design' },
    //         { programId: 'PBA-TI', id: 231611, name: 'Web services Java' },
    //         { programId: 'PBA-TI', id: 231612, name: 'Intro mobile' },
    //         { programId: 'PBA-TI', id: 231613, name: 'Software project' },
    //         { programId: 'PBA-TI', id: 231614, name: 'Data foundations' },
    //         { programId: 'PBA-TI', id: 231615, name: 'Software trends' },
    //         { programId: 'PBA-TI', id: 231616, name: 'Vrijstellingspakket VT TI voor programmeren' },
    //         { programId: 'PBA-TI', id: 231617, name: '.NET OOP' },
    //         { programId: 'PBA-TI', id: 231618, name: 'Bachelorproef en stage_U' },
    //         { programId: 'PBA-TI', id: 231619, name: 'AI and Society' },
    //         { programId: 'PBA-TI', id: 231620, name: 'AI for Business' },
    //         { programId: 'PBA-TI', id: 231621, name: 'Trends in AI' },
    //         { programId: 'PBA-TI', id: 231622, name: 'Applied AI project' },
    //         { programId: 'PBA-TI', id: 231623, name: 'Vrijstellingspakket VT TI voor programmeren (6st)' },
    //         { programId: 'PBA-TI', id: 231624, name: 'Uitdovend vrijstellingspakket VT AI' },
    //         { programId: 'PBA-TI', id: 231625, name: 'Uitdovend vrijstellingspakket VT Business' },
    //         { programId: 'PBA-TI', id: 231626, name: 'Multidisciplinair IoT project_A_6SP' },
    //         { programId: 'PBA-TI', id: 231627, name: 'International bachelor thesis & internship_A' },
    //         { programId: 'PBA-TI', id: 233165, name: 'Business project analysis' },
    //         { programId: 'PBA-TI', id: 233166, name: 'Software project analysis' },
    //         { programId: 'PBA-TI', id: 233167, name: 'AI project analysis' },
    //         { programId: 'PBA-TI', id: 233360, name: 'Bachelorproef eindproject AI' },
    //         { programId: 'PBA-TI', id: 233361, name: 'Vrijstellingspakket TI-AI verkort progr. voor PBA-EA deel 1' },
    //         { programId: 'PBA-TI', id: 233362, name: 'Vrijstellingspakket TI-AI verkort progr. voor PBA-EA deel 2' },
    //         { programId: 'PBA-TI', id: 233363, name: 'Vrijstellingspakket TI-AI verkort progr. voor PBA-TI deel 1' },
    //         { programId: 'PBA-TI', id: 233364, name: 'Vrijstellingspakket TI-AI verkort progr. voor PBA-TI deel 2' },
    //         { programId: 'PBA-TI', id: 233592, name: 'Python programming' },
    //         { programId: 'PBA-TI', id: 233698, name: 'Software project_int week' },
    //         { programId: 'PBA-TI', id: 233699, name: 'Business project_int week' },
    //         { programId: 'PBA-TI', id: 233700, name: 'AI project_int week' },
    //         { programId: 'PBA-TI', id: 233728, name: 'Vrijstellingspakket 1' },
    //         { programId: 'PBA-TI', id: 233729, name: 'Vrijstellingspakket 2A' },
    //         { programId: 'PBA-TI', id: 233743, name: 'Multidisciplinair IoT project_A' },
    //         { programId: 'PBA-EA', id: 230661,  name: 'Robot dynamics' },
    //         { programId: 'PBA-EA', id: 230598,  name: 'Enterprise Networking' }
    //     ];

    //     return tx.table('courses').bulkPut(seedCourseUnits);
    // }
    constructor() {
        super('ExamLocalDb_v4');

        this.version(1).stores({
            exams: 'id, start',  // PK & index op date veld
            students: 'id, sNr',
            examStudents: 'id, examId, studentId',
            programs: 'id, name',
            courses: 'id, programId, name',
            scanHistory:'id, examId, examStudentId, date'
        }).upgrade(async tx => {
            console.log('SEEDING VERSION 1…');
        });

        // Version 2: voeg synced-veld toe voor offline-first sync naar API
        this.version(2).stores({
            exams: 'id, start',
            students: 'id, sNr',
            examStudents: 'id, examId, studentId',
            programs: 'id, name',
            courses: 'id, programId, name',
            scanHistory: 'id, examId, examStudentId, date, synced'
        }).upgrade(async tx => {
            // Bestaande scans werden al verstuurd door de oude code
            await tx.table('scanHistory').toCollection().modify({ synced: true });
        });

        // Dit wordt 1x uitgevoerd bij eerste creatie van de DB
        this.on('populate', async (tx) => {
            //await this.seedProgramsAndCourses(tx);
        })
    }
}

export const db = new AppDatabase();
